// extracted by mini-css-extract-plugin
export default {"container":"dcc_expandText-container","textContainer":"dcc_expandText-textContainer","expandButton":"dcc_expandText-expandButton"};